import {Modal, PickList, Show} from '@ultradent/components';
import AddPaymentForm from './AddPaymentForm';
import WalletItem from './WalletItem';
import Icon from '@components/common/Icon';

function setAddress ( addressBook ) {
    return item => {
        if ( item && item.addressId ) {
            item.address = addressBook.find( a => a.id === item.addressId ) || item.address;
        }
        return item;
    }
}

const HOVER_CLASSES = 'border border-transparent border-solid t-border-color t-duration-short hover:border-sky-blue cursor-pointer';
const ITEMS_CLASSES = 'rounded bg-near-white';

const AddressBook = ( {
                          addressBook,
                          paymentMethods,
                          defaultPaymentMethod,
                          itemIdProp,
                          groupId,
                          allowAddItem,
                          onPaymentOptionChange,
                          onPaymentAdded,
                          onAddressAdded,
                          error,
                          className
                      } ) => {
    // map addressBook to paymentItem
    const setAddressProp = setAddress( addressBook );
    const paymentMethodsList = paymentMethods.map( setAddressProp );
    const defaultPaymentMethodSelection = setAddressProp( defaultPaymentMethod );

    const isEmpty = !paymentMethodsList || !paymentMethodsList.length;

    return (
        <PickList
            itemType="payment method"
            itemIdProp={itemIdProp}
            groupId={groupId}
            list={paymentMethodsList}
            searchPlaceholder="Filter by name, vendor, or last 4 # on card"
            defaultSelection={defaultPaymentMethodSelection}
            allowAddItem={allowAddItem}
            onItemChange={onPaymentOptionChange}
            onItemAdded={onPaymentAdded}>
            {pickListProps => (
                <div className={className}>
                    <div className="lg:flex items-start w-full justify-between">
                        <h2 className="subheading-lg mb-4 lg:w-1/3">Payment Method</h2>
                        <PickList.EditAction className="lg:w-1/6 inline-block link-3 mb-2 lg:px-4 lg:order-last"/>
                        {isEmpty
                            ? <p className="mt-2 flex items-center lg:w-1/2">
                                <Icon.ui name="report-problem-triangle" className="text-lg mr-2"/>
                                No payment methods available
                            </p>
                            : <div className="lg:w-1/2">
                                <PickList.Selection
                                    className={ITEMS_CLASSES}
                                    interactionClassName={HOVER_CLASSES}
                                    itemRenderer={WalletItem}/>
                                <PickList.List
                                    queryProps={['lastFour', 'issuer', 'cardholder', 'meta']}
                                    itemRenderer={WalletItem}/>
                                <Show when={error}>
                                    <span className="input-feedback error">{error}</span>
                                </Show>
                            </div>
                        }
                    </div>
                    <Modal
                        title="Add a new credit card"
                        id="addItemDialog"
                        size="sm"
                        isOpen={pickListProps.isAddingItem}
                        onClose={pickListProps.actions.toggleAddItem}>
                            <AddPaymentForm
                                addressBook={addressBook}
                                onCancel={pickListProps.actions.toggleAddItem}
                                onAddressAdded={onAddressAdded}
                                onPaymentAdded={payload => {
                                    pickListProps.actions.handleItemAdded( payload );
                                    pickListProps.actions.toggleAddItem();
                                }}/>
                        </Modal>
                    </div>
            )}
        </PickList>
    );
}

AddressBook.defaultProps = {
    itemIdProp: 'id',
    groupId: 'walletPickList',
    paymentMethods: [],
    defaultPaymentMethod: null,
    addressBook: [],
    allowAddItem: false,
    onPaymentOptionChange: () => {
    },
    onPaymentAdded: () => {
    },
    onAddressAdded: () => {
    }
};

export default AddressBook;
